// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b0c7b0fc","239":"c5f68727","453":"825386d9","732":"78a3d36f","977":"c1528a18"}[chunkId] + ".chunk.js";
};